/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  /* 2026-09-01: 4 -> 5. A "Nemrég megtekintett" sor kiszűri az éppen
     nézett terméket, az viszont mindig benne van a tárolt listában (a
     megtekintéskor a lista elejére kerül). Négy tárolt elemnél tehát
     MINDIG csak három maradt — nem véletlenszerűen, hanem szerkezetileg.
     Öttel a sor megbízhatóan négyet mutat, ami a rács
     (repeat(4, 1fr)) egy teljes sora. A modult a prediktív keresés is
     használja; ott eggyel több elem jelenik meg, ami nem zavaró. */
  static #MAX_PRODUCTS = 5;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
